let basePath = "http://192.168.100.5:9005"

let api = {
  authorize:`${basePath}/api/authorize/`,
  getCardInfo:`${basePath}/api/tbcard/getCardInfo/`,
  createCard:`${basePath}/api/tbcard/createCard/`,
  getIndustry:`${basePath}/api/tbindustry/getIndustry/`,
  getModeInfo:`${basePath}/api/tbcardtemplate/getModeInfo/`,
  applyMode:`${basePath}/api/cardTemplateHave/applyMode/`,
  getIndustryTree: `${basePath}/api/tbindustry/getIndustryTree/`
}
export default api